import React from "react";
import _ from "lodash";
import Text from "theme/Text";
import { View } from "react-native";
import { textProps } from "styles/text";
import ThemedPressable from 'components/atoms/ThemedPressable'
import isEqual from 'react-fast-compare'
import { navigationButtonStyles } from 'styles/components/atoms/NavigationButton'


const NavigationButton = ({ accessoryLeft, accessoryRight, text, textStyle, onPress, testID }) => {
	
	let alignItems = 'center';
	if( _.isFunction( accessoryLeft ) ) {
		alignItems = 'flex-start';
	}
	if( _.isFunction( accessoryRight ) ) {
		alignItems = 'flex-end';
	}
	
	const textViewStyle = [
		navigationButtonStyles.textView,
		{
			alignItems: alignItems,
		}
	]
	
	return (
		<ThemedPressable
			onPress={ onPress }
			hitSlop={ 20 }
			testID={testID}>
			
			<View style={ navigationButtonStyles.innerView }>
				{ _.isFunction( accessoryLeft ) && (
					<View style={ navigationButtonStyles.accessoryView }>
						{ accessoryLeft() }
					</View>
				)}
				
				<View style={ textViewStyle }>
					<Text
						style={ textStyle }
						{ ...textProps.fit }>
						
						{ text }
					</Text>
				</View>
				
				{ _.isFunction( accessoryRight ) && (
					<View style={ navigationButtonStyles.accessoryView }>
						{ accessoryRight() }
					</View>
				)}
				{ accessoryRight && (
					<View style={ navigationButtonStyles.accessoryView }>
						{ accessoryRight }
					</View>
				)}
			</View>
		</ThemedPressable>
	)
}

export default React.memo( NavigationButton, isEqual );
